import React, { useEffect, useState } from "react";
import InnerHeader from "../etc/innerheader";
import styles from "../restaurant/mobilerestaurantstatus.module.css";
import { useLocation } from "react-router-dom";
import { Capacitor } from "@capacitor/core";
import {Clipboard} from "@capacitor/clipboard";

import {ReactComponent as Paste} from "../../../src/svg/paste-light.svg";
import { useIonAlert } from '@ionic/react';
import { returnAccountInfo } from "../../data/locationFuntion";


const MobileContentText: React.FC<any> = (props) => {

    const location : any = useLocation();
    const [numbers, setNumbers] = useState<number>(0);
    const [selectedPhoneNumber, setSelectedPhoneNumber] = useState<string>("");
    const [totalPrice, setTotalPrice] = useState<number>(0);
    const [presentAlert] = useIonAlert();

    useEffect(() => {

        const newNumbers = location.state.numbers;
        const newSelectedPhoneNumber = location.state.selectedPhoneNumber;
        const totalPrice = location.state.totalPrice;

        setTotalPrice(totalPrice);
        setNumbers(newNumbers);
        setSelectedPhoneNumber(newSelectedPhoneNumber);
        
    }, []);

    return (
        <div>
            <InnerHeader title="컨텐츠 구매 신청" home={true} />
            <div className={styles.chargeBody}>
                <div className={styles.chargeTitle}>
                    컨텐츠 구매 신청이 완료되었습니다
                </div>
                <div className={styles.chargeSubTitle}>
                    신청해주신 컨텐츠에 대한<br></br>
                    결제선생 결제 링크가 전송되었습니다.<br></br>
                    결제완료 즉시 구매완료 처리됩니다.
                </div>

                <div className={styles.infoBox}>
                    <div className={styles.infoBoxTitle}>
                        <div>
                            컨텐츠 결제 안내
                        </div>
                    </div>
                    <div className={`${styles.sendInfoBox} ${styles.second}`}>
                        <div className={styles.sendInfo}>
                            [컨텐츠 구매 신청 내역]
                        </div>
                        <div className={styles.sendInfo}>
                            - 컨텐츠 수량 : {numbers}장
                        </div>
                        <div className={styles.sendInfo}>
                            - 결제금액 : {(totalPrice).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}원
                        </div>
                        <div className={styles.sendInfo}>
                            - 전송된 번호 : {selectedPhoneNumber}
                        </div>
                    </div>
                </div>

            </div>

        </div>
    )
}

export default MobileContentText;